// Layout related texts
export const LAYOUT_TEXTS = {
  openDrawer: 'open drawer',
  accountOfCurrentUser: 'account of current user',
  profileMenu: 'profile-menu'
} as const;